export const initialState = {
  questionNumber: 0,
  needToRelyOnSocialSecurity: undefined,
  concernedWithSpouseIncomeAfterDeath: undefined,
  workPartTimeInRetirement: undefined,
  lifeExpectancyPrimary: undefined,
  lifeExpectancyPartner: undefined,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'EDIT_SOCIAL_SECURITY_QUIZ':
      console.log(action.type, action.key, action.value, state);
      return Object.assign({}, state, { [action.key]: action.value });
    default:
      return state;
  }
}
